module.exports = "<template>\r\n    <section ref=\"editorMarkupRef\"></section>\r\n</template>\r\n";